import { Box, styled, Tooltip } from '@mui/material';
import SvgIcon from '../SvgIcon';
import { ReactComponent as RemoveIcon } from '../../assets/icons/32/remove.svg';
import { ReactComponent as BonusIcon } from '../../assets/icons/32/bonus.svg';
import { ReactComponent as AddIcon } from '../../assets/icons/32/add.svg';
import { TOOLTIP_SLOT_PROPS } from '../../constants/tooltip';

const ActionsCellWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
  '& .action-icons': {
    opacity: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    transition: 'opacity 0.2s ease',
  },
});

const ActionIconButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$accent',
})(({ $accentColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: 0,
  borderRadius: 4,
  '&:hover': {
    ...($accentColor && { color: $accentColor }),
  },
}));

const DriversActionsCell = ({ data, onGiveBonus, onAddBalance, onSelectRow, onRemove }) => {
  if (!data || data.id === 'footer') return null;

  const selectAndRun = (handler) => (e) => {
    onSelectRow?.(data);
    handler(e);
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    onRemove?.(data);
  };

  const handleBonus = (e) => {
    e.stopPropagation();
    onGiveBonus?.();
  };

  const handleAddBalance = (e) => {
    e.stopPropagation();
    onAddBalance?.();
  };

  return (
    <ActionsCellWrapper>
      <Box className="action-icons">
        <Tooltip
          title="Supprimer le chauffeur"
          placement="bottom"
          arrow
          slotProps={TOOLTIP_SLOT_PROPS}
        >
          <ActionIconButton
            $accentColor="#FF6B6B"
            onClick={selectAndRun(handleRemove)}
            aria-label="Supprimer le chauffeur"
            sx={{ color: '#ACACAC' }}
          >
            <SvgIcon icon={RemoveIcon} color="inherit" size={24} />
          </ActionIconButton>
        </Tooltip>
        <Tooltip title="Donner un bonus" placement="bottom" arrow slotProps={TOOLTIP_SLOT_PROPS}>
          <ActionIconButton
            $accentColor="#B9FF66"
            onClick={selectAndRun(handleBonus)}
            aria-label="Donner un bonus"
            sx={{ color: '#ACACAC' }}
          >
            <SvgIcon icon={BonusIcon} color="inherit" size={24} />
          </ActionIconButton>
        </Tooltip>
        <Tooltip title="Ajouter un solde" placement="bottom" arrow slotProps={TOOLTIP_SLOT_PROPS}>
          <ActionIconButton
            $accentColor="#B9FF66"
            onClick={selectAndRun(handleAddBalance)}
            aria-label="Ajouter un solde"
            sx={{ color: '#ACACAC' }}
          >
            <SvgIcon icon={AddIcon} color="inherit" size={24} />
          </ActionIconButton>
        </Tooltip>
      </Box>
    </ActionsCellWrapper>
  );
};

export default DriversActionsCell;
